import { useEffect } from 'react';
import { motion, AnimatePresence } from 'framer-motion';

function ErrorNotification({ message, duration = 10000, onClose,img, centered = false }) {
    useEffect(() => {
        const timer = setTimeout(() => {
            onClose();
        }, duration);

        return () => clearTimeout(timer);
    }, [duration, onClose]);

    const notificationVariants = {
        hidden: { opacity: 0, x: 50 },
        visible: { opacity: 1, x: 0 },
        exit: { opacity: 0, x: 50 },
    };

    // Centered, medium-sized variant for form errors that must not be missed
    if (centered) {
        return (
            <AnimatePresence>
                <div
                    style={{
                        position: 'fixed',
                        inset: 0,
                        display: 'flex',
                        alignItems: 'center',
                        justifyContent: 'center',
                        padding: '16px',
                        zIndex: 9999,
                        pointerEvents: 'none',
                    }}
                >
                    <motion.div
                        role="alert"
                        dir="rtl"
                        className="df"
                        initial={{ opacity: 0, scale: 0.9 }}
                        animate={{ opacity: 1, scale: 1 }}
                        exit={{ opacity: 0, scale: 0.9 }}
                        transition={{ type: "spring", stiffness: 400, damping: 30 }}
                        style={{
                            pointerEvents: 'auto',
                            width: '100%',
                            maxWidth: '440px',
                            background: '#fff5f5',
                            color: '#b91c1c',
                            border: '2px solid #f87171',
                            fontWeight: 'bold',
                            fontSize: '1.05rem',
                            lineHeight: 1.7,
                            padding: '20px 24px',
                            borderRadius: '12px',
                            boxShadow: '0 10px 30px rgba(0, 0, 0, 0.25)',
                            gap: '12px',
                            alignItems: 'flex-start',
                        }}
                    >
                        <div style={{ flex: 1 }}>{message}</div>
                        <button
                            type="button"
                            aria-label="إغلاق"
                            onClick={onClose}
                            style={{ fontSize: '1.4rem', lineHeight: 1, color: '#b91c1c', background: 'none', border: 'none', cursor: 'pointer' }}
                        >
                            ×
                        </button>
                    </motion.div>
                </div>
            </AnimatePresence>
        );
    }

    return (
        <AnimatePresence>
            <motion.div
                className="notification-pop-up df success"
                initial="hidden"
                animate="visible"
                exit="exit"
                variants={notificationVariants}
                transition={{ type: "spring", stiffness: 500, damping: 30 }}
                style={{
                    position: 'fixed',
                    bottom: '4rem',
                    right: '20px',
                    background: 'var(--error-light)',
                    color: 'var(--error)',
                    fontWeight: 'bold',
                    padding: '10px 20px',
                    borderRadius: '8px',
                    boxShadow: '0px 4px 6px rgba(0, 0, 0, 0.1)',
                    zIndex: 9999,
                }}
            >
                <div className="w-16 h-16">
            <img src={`${img ? img : '/img/_.png'}`} className='w-full h-full object-cover' alt="" />

        </div>
        <div>
             
                {message}
        </div>
            </motion.div>
        </AnimatePresence>
    );
}

export default ErrorNotification;
